module.exports = __webpack_public_path__ + "img/image003.27dd963c.jpg";